// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"424":"5f2622ac","642":"74a97480","972":"be6ac079"}[chunkId] + ".chunk.css";
};